import { FC } from 'react'
import styled, { css } from 'styled-components'
import { Box } from '../../UI/Box'
import { useShouldShowForThreshold } from '../../../theme'
import { H1, P, Span } from '../Typeography'
import dropsLogo from './assets/drops/drops-logo.svg'
import { ThemedLink } from '../../ThemedButton'

const Hero = ({
  Title,
  Subtitle,
  ExtraText,
  CallsToAction,
  imageUrl,
  bgColor,
  hasFullHeightImage,
  hasNoLeftPadding,
}: {
  Title: FC
  Subtitle: FC
  ExtraText?: FC
  CallsToAction: FC
  imageUrl: string
  bgColor?: string
  hasFullHeightImage?: boolean
  hasNoLeftPadding?: boolean
}) => {
  const isAtLeastMediumDisplaySize = useShouldShowForThreshold('medium')

  return (
    <Box padV="section">
      <HeroContainer bgColor={bgColor} br={12} dc={!isAtLeastMediumDisplaySize}>
        <ContentSection
          indexGuttersPadding
          hasNoLeftPadding={hasNoLeftPadding}
          padV={40}
          padH={24}
        >
          <Title />
          <Subtitle />
          {ExtraText && <ExtraText />}
          <CallsToAction />
        </ContentSection>
        <Box
          className={`image-container ${
            hasFullHeightImage ? 'full-height' : ''
          }`}
          ac
        >
          <img src={imageUrl || ''} alt="Hero bannner" className="right" />
        </Box>
      </HeroContainer>
    </Box>
  )
}

export default Hero

const DropsTitle = () => {
  return (
    <DropsHeroContainer dc>
      <img src="/img/base-wide.png" alt="Base Logo" className="base-logo" />
      <Box g={6} padV="l" ac>
        <H1 uc s="3XL">
          Giga
        </H1>
        <Box>
          <img src={dropsLogo} alt="drops logo" className="drops-logo" />
        </Box>
      </Box>
    </DropsHeroContainer>
  )
}

const DropsSubtitle = () => (
  <Box dc padB="l">
    <Span s="L" fw="semibold">
      All the best projects on Base from AI, Perps, Games, DeFi and more. Earn
      rewards for completing missions and discovering some of Base’s best
      builders!
    </Span>
  </Box>
)

const DropsExtraText = () => (
  <Box g={10} ac padB="l">
    <P s="M" fw="regular">
      In partnership with
    </P>
    <Box g={10}>
      <a
        href="https://www.coinbase.com"
        target="_blank"
        rel="noreferrer"
        title="Coinbase - Buy and Sell Bitcoin, Ethereum, and more with trust"
      >
        <img src="/base-coinbase.svg" alt="Coinbase logo" />
      </a>
      <a
        href="https://www.bitget.com"
        target="_blank"
        rel="noreferrer"
        title="Bitget Exchange: Crypto Trading Platform"
      >
        <img src="/bitget.svg" alt="Bitget logo" />
      </a>
      <a
        href="https://www.bybit.com/web3/home"
        target="_blank"
        rel="noreferrer"
        title="Bybit: Buy & Sell Bitcoin, Ether | Cryptocurrency Exchange"
      >
        <img src="/bybit.svg" alt="Bybit logo" />
      </a>
      <a
        href="https://www.nansen.ai/"
        target="_blank"
        rel="noreferrer"
        title="Nansen | Onchain Analytics for Crypto Investors & Teams"
      >
        <img src="/nansen.svg" alt="Nansen logo" />
      </a>
    </Box>
  </Box>
)

const DropsCallsToAction = () => (
  <Box ac g={10}>
    {/*<ThemedButton $styleType="primary" disabled>*/}
    {/*  Coming Soon*/}
    {/*</ThemedButton>*/}
    <ThemedLink $styleType="surface-chip-default-text" to="/article/zap-drops">
      About Drops
    </ThemedLink>
  </Box>
)

export const DropsHero = () => {
  return (
    <Hero
      Title={DropsTitle}
      Subtitle={DropsSubtitle}
      ExtraText={DropsExtraText}
      CallsToAction={DropsCallsToAction}
      imageUrl="/img/on-chain-summer.png"
      bgColor="#0052FF"
    />
  )
}

type ContentSectionProps = {
  indexGuttersPadding: boolean
  hasNoLeftPadding?: boolean
}

const ContentSection = styled(Box)<ContentSectionProps>`
  flex-direction: column;
  ${({ hasNoLeftPadding }) =>
    hasNoLeftPadding &&
    css`
      padding-left: 0;
    `}
`

const DropsHeroContainer = styled(Box)`
  img.base-logo {
    max-width: 238px;
    @media screen and (max-width: ${({ theme }) =>
        theme.breakpoints.expanded}px) {
      max-width: 204px;
    }
    @media screen and (max-width: ${({ theme }) =>
        theme.breakpoints.medium}px) {
      max-width: 172px;
    }
  }
  img.drops-logo {
    min-width: 189px;
    margin-top: -2px;
    @media screen and (max-width: ${({ theme }) =>
        theme.breakpoints.medium}px) {
      max-width: 135px;
      min-width: 135px;
    }
  }
`

// overriding bgc prop on Box incase non-theme color is passed
const HeroContainer = styled(Box)<{ bgColor?: string }>`
  ${({ bgColor }) =>
    bgColor &&
    css`
      background-color: ${bgColor};
    `};

  align-items: center;
  .image-container {
    min-height: 326px;
  }
  .image-container.full-height {
    min-height: 300px;

    img {
      min-height: 300px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
    .image-container {
      min-height: 160px;
    }
  }
  img.right {
    width: auto;
  }
`
